<template>
  <FKBreadCrumb :page="$t('page.users')" />
  <div class="card border-0 bg-white profile-settings-card rounded-0">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <ZonesHCPList :zone_id="zone_id"/> 
    </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import ZonesHCPList from "@/components/FK/Zones/ZonesHCPList.vue";
import stateStore from "@/utils/store";

export default defineComponent({
  name: "ZonesHCPPage",
  components: {
    FKBreadCrumb,
    ZonesHCPList,
  },
  data() {
    return {
      zone_id: stateStore.user?.info.zone_id ?? '',
    };
  },
  mounted() {
    if(stateStore.user?.info.zone_id === undefined || stateStore.user?.info.zone_id === null) {
      this.$router.push({ name: 'Welcome' });
    }
  },
});
</script>